import { PageLayout } from "~/components/PageLayout";
import { ResetPasswordForm } from "~/features/auth/components/ResetPasswordForm";
import { useTrackPageVisit } from "~/hooks/useTrackPageVisit";

export const ResetPasswordPage = () => {
  useTrackPageVisit("app/reset_password/visit");

  return (
    <PageLayout>
      <ResetPasswordForm />
    </PageLayout>
  );
};
